import React from "react";
import "../../loader.css"

const Loader = () => {
  return (
    <div style={{height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",backgroundColor:"#49688e"}}>
        <div class="loader">Loading...</div>;
    </div>
  )
};

export default Loader;
